module.exports = __webpack_public_path__ + "static/img/accounts-page.a57dd4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/accounts-page.jpg
// module id = RuU8
// module chunks = 1